// extracted by mini-css-extract-plugin
export default {"aboutUs":"about_aboutUs__zsUKz","content":"about_content__YOKjX","greenText":"about_greenText__1gGhj"};